import React, { Component } from 'react';
import {Row, Col} from 'react-bootstrap';
import play_icon from '../images/play-icon.png';
import google_i from '../images/google.png';
import github_i from '../images/github.png';
import amazon_i from '../images/amazon.png';
import basecamp_i from '../images/basecamp.jpg';
import invision_i from '../images/invision.jpg';
import profile from '../images/icons/no_image.png';
import Header from './Header';
import Footer from './Footer';
import '../styles/components/joblisting.css';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

class JobListing extends Component {

    state = {
        jobs: []
    }

    searchType = (e)=>{
        let query = e.target.value;
        this.setState({
            jobs: this.props.vacancies.filter((job) => { 
                const jobName = job.jobTitle.toLowerCase().includes(query.toLowerCase())
                const description = job.data.includes(query)
                const companyName = job.companyName.toLowerCase().includes(query.toLowerCase())
                return jobName || description || companyName
             }).sort((a,b) => {
                return a.names < b.names
            })
        })
    }

    componentDidMount(){
        window.scrollTo(0, 0);
        this.setState({
            jobs: this.props.vacancies
        })
    }

    seeMore = (id) => {
        this.props.history.push(`/jobdetail/${id}`)
    }

    render(){
        return(
            <div className="container">
                <Row><Header {...this.props}/></Row>
                <Row>
                    <Col className="p-none" xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className="play-video">
                            <img className="play-button" alt="play-icon" src={play_icon}/>
                            <p className="video-text">Tu búsqueda comienza aquí.</p>
                        </div>
                    </Col>
                </Row>
                <Row className="companies p-b-2">
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <p className="text-companies">Trabaja con estas empresas</p>
                    </Col>
                    <Col xs={8} sm={8} md={8} lg={8} className="companies-links">
                        <img alt="" className="company" src={google_i}/>
                        <img alt="" className="company" src={amazon_i}/>
                        <img alt="" className="company" src={github_i}/>
                        <img alt="" className="company" src={basecamp_i}/>
                        <img alt="" className="company" src={invision_i}/>
                    </Col>
                </Row>
                <Row>
                    <Col className="no-float mx-auto" xs={12} sm={11} md={10} lg={9} xl={9}>
                        <div className="jb-titles">
                            <p className="job-category">Estas son las vacantes que tenemos para ti.</p>
                            <label htmlFor="searchBox" className="search-place">Búsqueda rápida</label>
                            <input type='text' id="searchBox" className="search-input" onChange={this.searchType}/>
                        </div>
                        <div className="job-list">
                        {this.state.jobs.map((job) => {
                            if(job.Status && job.Permission === "accept"){
                                return <div key={job.jobID} className="job-item" onClick={() => {this.seeMore(job.jobID)}}>
                                    <div className="icon-side">
                                        {job.companyLogo !== "" ? <img src={job.companyLogo === "" ? profile : job.companyLogo} className="job-icon" alt="ji"/>:
                                        null}
                                    </div>
                                    <div className="info-side-jl">
                                        <p className="company-name">{job.companyName}</p>
                                        <p className="job-name">{job.jobTitle}</p>
                                        <p className="timing">{job.contract}</p>
                                        <p className="timing">{job.locationName}</p>
                                    </div>
                                    <div className="tags-side">
                                        {job.origin ? <p className="category border-jl">Empresa Top</p> : null}
                                </div> </div>
                            }
                        })}

                        {this.state.jobs.length === 0 ? 
                        <p className="no-results">No hay resultados para esta búsqueda</p> : 
                        null}
                        </div>
                    </Col>
                </Row>
                <Row><Footer /></Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    id: state.auth.uid,
    vacancies: state.vacancies
})

const mapDispatchToProps = (dispatch) => ({
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobListing));